import SimpleNavTabs, { Tab } from '@/common/components/SimpleNavTabs.tsx'
import { AppRoutePaths } from '../../../../routing/route_paths.ts'
import { Outlet, useParams, useLocation } from 'react-router-dom'
import { useApplication } from './ApplicantContext.tsx'
import ApplicationStatusBadge from '@/common/components/StatusBadge.tsx'

const Paths = AppRoutePaths.applicants.applicant_details

export default function ApplicantsDetailsPage() {
  const { headerData } = useApplication()
  const { applicantId } = useParams<{ applicantId: string }>()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const flagId = searchParams.get('flag_id')
  const taskId = searchParams.get('task_id')
  const queryParams = `${flagId ? `?flag_id=${flagId}` : ''}${
    taskId ? `${flagId ? '&' : '?'}task_id=${taskId}` : ''
  }`

  const Tabs: Tab[] = [
    {
      name: 'Application',
      href: `${Paths.application.replace(':applicantId', applicantId || '')}${queryParams}`,
    },
    /*  {
      name: 'Appeals',
      href: Paths.appeals.replace(':applicantId', applicantId || ''),
    }, */
    {
      name: 'History',
      href: `${Paths.history.replace(':applicantId', applicantId || '')}${queryParams}`,
    },
    {
      name: 'Chat',
      href: `${Paths.chat.replace(':applicantId', applicantId || '')}${queryParams}`,
    },
    {
      name: 'Documents',
      href: `${Paths.documents.replace(':applicantId', applicantId || '')}${queryParams}`,
    },
    {
      name: 'Payments',
      href: `${Paths.payments.replace(':applicantId', applicantId || '')}${queryParams}`,
    },
  ]

  return (
    <div className="flex flex-col  h-full">
      {headerData && headerData?.name && (
        <h1 className="text-xl font-bold leading-none text-gray-900 gap-2 flex mb-5">
          <div>{headerData?.name}</div>
          {headerData?.status && !(headerData?.hideStatus ?? true) && (
            <ApplicationStatusBadge status={headerData?.status} />
          )}
        </h1>
      )}
      <SimpleNavTabs tabs={Tabs} />
      <Outlet />
    </div>
  )
}
